import React, { useRef, useEffect } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const DdosTerminal = ({
  logs = [],
  packetsSent = 0,
  dataMb = 0,
  sessionTime = '00:00',
  isRunning = false,
  statusText,
  activeWorkers = 0,
  onClearLogs,
  onCopyLogs
}) => {
  const { language } = useLanguage();
  const isEn = language === 'en';

  const logBodyRef = useRef(null);

  // Auto-scroll to bottom on new log lines
  useEffect(() => {
    if (logBodyRef.current) {
      logBodyRef.current.scrollTop = logBodyRef.current.scrollHeight;
    }
  }, [logs]);

  const defaultStatus = isRunning
    ? isEn
      ? 'Load traffic generation active'
      : 'Генерация потока нагрузки активна'
    : isEn
    ? 'Awaiting launch command'
    : 'Ожидание команды запуска';

  return (
    <div className="terminal-card">
      {/* Шапка терминала с macOS точками */}
      <div className="terminal-header">
        <div className="terminal-left-wrap">
          <div className="terminal-window-dots hidden sm:flex">
            <span className="t-dot red" />
            <span className="t-dot yellow" />
            <span className="t-dot green" />
          </div>
          <div className="terminal-title-text">
            <span>{isEn ? 'Monitoring' : 'Мониторинг'}</span>
          </div>
        </div>

        <div className="terminal-header-tools">
          <button
            type="button"
            className="t-tool-btn"
            onClick={onClearLogs}
            title={isEn ? 'Clear logs' : 'Очистить терминал'}
          >
            {isEn ? 'Clear' : 'Очистить'}
          </button>
          <button
            type="button"
            className="t-tool-btn"
            onClick={onCopyLogs}
            title={isEn ? 'Copy logs' : 'Копировать'}
          >
            {isEn ? 'Copy' : 'Копировать'}
          </button>
        </div>
      </div>

      {/* Метрики в реальном времени */}
      <div className="terminal-stats-strip terminal-metrics-bar">
        <div className="t-stat-item t-metric-item">
          <span className="t-stat-label t-metric-label">
            {isEn ? 'Packets Sent' : 'Отправлено пакетов'}
          </span>
          <span className="t-stat-value t-metric-value">{packetsSent.toLocaleString()}</span>
        </div>
        <div className="t-stat-item t-metric-item">
          <span className="t-stat-label t-metric-label">
            {isEn ? 'Data Sent' : 'Отправлено данных'}
          </span>
          <span className="t-stat-value t-metric-value">{dataMb.toFixed(1)} MB</span>
        </div>
        <div className="t-stat-item t-metric-item">
          <span className="t-stat-label t-metric-label">
            {isEn ? 'Session Time' : 'Время сессии'}
          </span>
          <span className="t-stat-value t-metric-value">{sessionTime}</span>
        </div>
      </div>

      {/* Лог консоли */}
      <div className="terminal-body" ref={logBodyRef}>
        {logs.map((log, index) => {
          const tagClass = log.tagClass || (log.type === 'error' ? 'error' : log.type === 'warning' ? 'alert' : 'system');
          return (
            <div key={index} className="t-log-line log-line">
              <span className="t-log-time log-time">{log.time || log.timestamp || '[00:00:00]'}</span>
              <span className={`t-log-tag log-tag ${tagClass}`}>
                {log.tagText || (log.type ? `[${log.type.toUpperCase()}]` : '[LOG]')}
              </span>
              <span className="t-log-text log-text">{log.text}</span>
            </div>
          );
        })}
      </div>

      {/* Футер терминала */}
      <div className="terminal-footer">
        <div className="terminal-status-indicator">
          <span className={`t-pulse-dot ${isRunning ? 'active' : ''}`} />
          <span>{statusText || defaultStatus}</span>
        </div>
        <span className="terminal-workers-count">
          {isEn ? `Active workers: ${activeWorkers}` : `Воркеров активно: ${activeWorkers}`}
        </span>
      </div>
    </div>
  );
};

export default DdosTerminal;
